import {
  FETCH_QUESTIONNAIRE_REQUEST,
  FETCH_QUESTIONNAIRE_SUCCESS,
  FETCH_QUESTIONNAIRE_FAILURE,
  SUBMIT_QUESTIONNAIRE_REQUEST,
  SUBMIT_QUESTIONNAIRE_SUCCESS,
  SUBMIT_QUESTIONNAIRE_FAILURE,
} from "../actions/QuestionnaireTypes";

import {
  FETCH_ANSWERS_REQUEST,
  FETCH_ANSWERS_SUCCESS,
  FETCH_ANSWERS_FAILURE,
  SAVE_ANSWERS_REQUEST,
  SAVE_ANSWERS_SUCCESS,
  SAVE_ANSWERS_FAILURE,
} from "../actions/QuestionnaireActions";

const initialState = {
  loading: false,
  error: null,
  fields: [],
  answers: {
    data: [],
    loading: false,
    error: null,
  },
  submitting: false,
  submitError: null,
};

export default function questionnaireReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_QUESTIONNAIRE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_QUESTIONNAIRE_SUCCESS:
      console.log(
        "Reducer - FETCH_QUESTIONNAIRE_SUCCESS payload:",
        action.payload
      );
      console.log("Reducer - fields being set:", action.payload.fields);
      console.log("Reducer - fields length:", action.payload.fields?.length);
      return {
        ...state,
        loading: false,
        fields: action.payload.fields,
        error: null,
      };

    case FETCH_QUESTIONNAIRE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SUBMIT_QUESTIONNAIRE_REQUEST:
      return {
        ...state,
        submitting: true,
        submitError: null,
      };

    case SUBMIT_QUESTIONNAIRE_SUCCESS:
      return {
        ...state,
        submitting: false,
        answers: action.payload,
        submitError: null,
      };

    case SUBMIT_QUESTIONNAIRE_FAILURE:
      return {
        ...state,
        submitting: false,
        submitError: action.payload,
      };

    case FETCH_ANSWERS_REQUEST:
      return {
        ...state,
        answers: {
          ...state.answers,
          loading: true,
          error: null,
        },
      };

    case FETCH_ANSWERS_SUCCESS:
      return {
        ...state,
        answers: {
          data: action.payload,
          loading: false,
          error: null,
        },
      };

    case FETCH_ANSWERS_FAILURE:
      return {
        ...state,
        answers: {
          ...state.answers,
          loading: false,
          error: action.payload,
        },
      };

    case SAVE_ANSWERS_REQUEST:
      return {
        ...state,
        submitting: true,
        submitError: null,
      };

    case SAVE_ANSWERS_SUCCESS:
      return {
        ...state,
        submitting: false,
        submitError: null,
      };

    case SAVE_ANSWERS_FAILURE:
      return {
        ...state,
        submitting: false,
        submitError: action.payload,
      };

    default:
      return state;
  }
}
